
<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success"  v-if="false">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchApartmentReservation"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.reservation_code')"
                  v-model="search.reservation_code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchApartmentReservation"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.apartment_code')"
                  v-model="search.apartment_code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchApartmentReservation"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.customer_name')"
                  v-model="search.customer_name"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchApartmentReservation"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{$t('invoice_booking_payment.title')}}</b>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12 table-responsive no-padding">
                  <b-table :items="invoice_booking_payment_list" :fields="invoice_booking_payment_list_fields" class="mt-3" outlined>
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template slot="target" slot-scope="row">
                      <a :href="row.item.url" target="_blank" :id="`invoice_booking_payment_target_${row.item.id}`">{{row.item.target}}</a>
                      <tooltip :text="row.item.url" :target="`#invoice_booking_payment_target_${row.item.id}`"/>
                    </template>
                    <template slot="status" slot-scope="row">
                      {{$t(row.item.status)}}
                    </template>
                    <template slot="export_status" slot-scope="row">
                      {{$t(row.item.export_status)}}
                    </template>
                    <template slot="summary" slot-scope="row">
                      {{formatNumber(row.item.summary)}}
                    </template>
                    <template slot="actions" slot-scope="row">
                      <template>
                        <div class="btn-group">
                          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                            <i class="fa fa-fw fa-ellipsis-h"></i>
                          </button>
                          <ul class="dropdown-menu hide-scroll-bar" style="min-width: 50px;max-height: 80px;">
                            <li >
                              <button
                              class="btn btn-primary btn-sm"
                              style="margin-left: 6px;"
                              @click="showModalRowInvoiceBookingPayment(row.item)"
                            >
                              <i class="glyphicon glyphicon-edit"></i>
                            </button></li>
                              <li><button
                              class="btn btn-warning btn-sm"
                              style="margin-left: 6px;"
                              @click="showModalDelete(row.item)"
                            >
                              <i class="glyphicon glyphicon-trash"></i>
                            </button></li>
                          </ul>
                      </div>
                      </template>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row">
                <Paginator
                  :item="paginatorItem"
                  @onpaginate="onPagination"
                />
              </div>
            </div>
          </div>
        </div>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
      </row>
    </div>
    <!-- Modal Booking Payment -->
    <div class="modal fade" :ref="`modal-booking-payment`">
      <div class="modal-dialog modal-lg">
        <LeaseBackBookingPayment
          :item="bookingPaymentData"
          :checkout_show="false"
          @onSave="onSavePayment"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- END Modal Booking Payment -->
    <!-- /.modal-content -->
    <div class="modal fade" ref="modal-confirm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">{{$t('common.delete_modal.title')}}</h1>
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group label-size="sm" label-for="input-sm" :label="$t('common.delete_modal.content') + '?'"> 
              </b-form-group>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onDelete()"
            >{{$t('common.delete_modal.btnYes')}}</button>
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils'
import LeaseBackBookingPayment from "./LeaseBackBookingPayment"
import Paginator from "@/components/Paginator.vue"

export default {
  name: "InvoiceBookingPaymentList",
  data() {
    return {
      bookingPaymentData: {
        id: 0,
        booking_id: 0,
        apartment_id: 0
      },
      // loitt
      invoice_booking_payment_list: [],
      invoice_booking_payment_list_fields: [
        // { key: 'stt', label: "invoice_booking_payment.stt", sortable: true, class: 'text-center' },
        { key: 'payment_code', label: 'invoice_booking_payment.payment_code', sortable: true, class: 'text-center' },
        { key: 'apartment_code', label: 'apartment.apartment_code', sortable: true, class: 'text-center' },
        { key: 'customer_name', label: 'invoice_booking_payment.customer_name', sortable: true, class: 'text-center' },
        { key: 'checkin_datetime', label: 'invoice_booking_payment.checkin_datetime', sortable: true, class: 'text-center'},
        { key: 'checkout_datetime', label: 'invoice_booking_payment.checkout_datetime', sortable: true, class: 'text-center'},
        { key: 'summary', label: 'invoice_booking_payment.summary', sortable: true, class: 'text-right' },
        { key: 'status', label: 'invoice_booking_payment.status', sortable: true, class: 'text-center' },
        { key: 'export_status', label: 'invoice_booking_payment.status', sortable: true, class: 'text-center' },
        { key: "actions", label: "common.action", class: 'text-center' }
      ],
      isLoading: false,
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
      },
      paginatorItem: {
        commit_function: "GET_BOOKING_PAYMENT_LIST"
      },
    };
  },
  watch: {
    BOOKING_PAYMENTS: function() {
      let invoice_booking_payment_list = []
      this.isLoading = false
      this.BOOKING_PAYMENTS.forEach((v, index) => {
        let item = {
          id: v.id,
          stt: index,
          payment_code: v.payment_code,
          apartment_code: v.apartment_details ? v.apartment_details.apartment_code : null,
          customer_name: v.booking_details ? v.booking_details.booking_person_name : null,
          checkin_datetime: v.booking_details ? utils.formatSqlDate(v.booking_details.checkin_datetime, null, this.options.format) : null,
          checkout_datetime: v.booking_details ? utils.formatSqlDate(v.booking_details.checkout_datetime, null, this.options.format) : null,
          summary: !utils.isNull(v.payment_amount_after_vat) ? v.payment_amount_after_vat : 0,
          status: v.status_details ? `apartmentbookings.paymentBooking.statusList.${v.status_details.name}`: null,
          export_status: this.getExportStatusName(v.payment_export_option),
          apt_booking: v.apt_booking,
          apartment: v.apartment
        }
        invoice_booking_payment_list.push(item)
      });
      this.invoice_booking_payment_list = invoice_booking_payment_list
    },
    GET_LANG: function() {
      this.GET_APARTMENT_RESERVATION_LIST().then(
        function(res) {
          // Todo on watch
        }
      ).catch(
        function(error) {
          this.isLoading = false
        }
      )
    },
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_LANG",
      "BOOKING_PAYMENTS"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_BOOKING_PAYMENT_LIST"
    ]),
    ...mapActions("bookingModule", [
      "SAVE_BOOKING_PAYMENT",
      "DELETE_BOOKING_PAYMENT"
    ]),
    formatNumber: function (n) {
      if ((n !== null) || (n !== 0)) {
        return utils.formatNumber(n)
      }
      return 0
    },
    onPagination: function(data) {
      this.getBiCycleList(data)
    },
    getPaymentList: function(data) {
      this.isLoading = true
      this.GET_BOOKING_PAYMENT_LIST(data).then(
        function() {
          this.isLoading = false
        }.bind(this)
      )
    },
    getExportStatusName: function(status)
    {
      if (status == ExportStatusEnum.NOT_EXPORT) {
        return this.$t("apartmentbookings.paymentBooking.exportoptionList.not_export")
      } else if (status == ExportStatusEnum.IN_EXPORT) {
        return this.$t("apartmentbookings.paymentBooking.exportoptionList.in_export")
      } else if (status == ExportStatusEnum.POST_EXPORT) {
        return this.$t("apartmentbookings.paymentBooking.exportoptionList.post_export")
      }
      return ""
    },
    onDelete: function(){
      this.DELETE_BOOKING_PAYMENT({id: this.bookingPaymentData.id})
        .then(
          function(res){
            this.onToggleDeleteBookingPaymentModal("hide")
            this.SUCCESS_TOAST()
            this.GET_BOOKING_PAYMENT_LIST()
          }.bind(this)
        )
        .catch(
          function(error) {
            this.onToggleDeleteBookingPaymentModal("hide")
            this.ERROR_TOAST()
          }.bind(this)
        )
    },
    onToggleBookingPaymentModal: function(action="show") {
      $(this.$refs[`modal-booking-payment`]).modal(action)
    },
    onToggleDeleteBookingPaymentModal: function(action="show") {
      $(this.$refs[`modal-confirm`]).modal(action)
    },
    showModalRowInvoiceBookingPayment: function(item) {
      const data = {
        id: 0,
        booking_id: item.apt_booking,
        apartment_id: item.apartment
      }
      this.bookingPaymentData = data
      this.onToggleBookingPaymentModal()
    },
    onSavePayment: function(id, saveBookingPayment){
      this.SAVE_BOOKING_PAYMENT({id: id, data: saveBookingPayment}).then(
        function(res){
          this.onToggleBookingPaymentModal("hide")
          this.getPaymentList()
        }.bind(this)
      )
    },
    showModalDelete: function(item){
      this.bookingPaymentData.id = item.id
      this.onToggleDeleteBookingPaymentModal()
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    LeaseBackBookingPayment,
    Paginator
  },
  mounted() {
    this.options.format = sessionStorage.getItem('projectDateViewOptions')
    this.isLoading = true
    this.GET_BOOKING_PAYMENT_LIST().then(
      function(res) {
        // Todo on watch
      }
    ).catch(
      function(error) {
        this.isLoading = false
      }
    )
  }
};
</script>

<style scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/InvoiceBookingPaymentList.vue